// extracted by mini-css-extract-plugin
module.exports = {"mb16":"EarnProducts_mb16_1B2ix","mainContainer":"EarnProducts_mainContainer_kFZZu","productsGrid":"EarnProducts_productsGrid__ABeg"};